exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".VcMLu1JgrB2gz_gtGpTmU{font-family:helvetica,arial,\"Hiragino Kaku Gothic ProN\",meiryo,sans-serif}", ""]);
// Exports
exports.locals = {
	"main": "VcMLu1JgrB2gz_gtGpTmU"
};